export default Object.freeze({
  Picture:
    "https://drive.google.com/uc?export=download&id=1Ex9EShFNydNLR18affyhFrdCdkl94Wxe",
  DisplayName: "จารวิน พรมสวัสดิ์",
  UserID: "Uec4968235386962e44770b681af153a5",
});
